import React, { useEffect } from 'react'
import useAuth from '../../context/auth/useAuth'
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from 'react-redux'
import { Container, Row, Col, Card } from 'react-bootstrap'
import { CustomDataTable } from '../../components/design/Datatables/CustomDataTable'
import { Link } from 'react-router-dom'
import { getReducedSchoolsByMultiSchool } from '../../actions/schoolsActions';

export default function Schools() {
    const { t } = useTranslation()
    const {client} = useAuth()
	const dispatch = useDispatch()

	const {schools} = useSelector(state=>state.schools)

    useEffect(() => {
		if(client){
			dispatch(getReducedSchoolsByMultiSchool(client.id))
		}
	},[client, dispatch])

	const columns = [
		{
			name: t('selection.school'),
			id: 'id',
			cell: school => school?.name,
			selector: (school) => school?.name,
			sortable: true,
		},{
            name: t('school.fee'),
            center: 'center',
			cell: school => school.plan?.fee?.name.charAt(0).toUpperCase() + school.plan?.fee?.name.slice(1),
		},{
			name: t('global.actions'),
			center: 'center',
			width: "120px",
			cell: school =>
				<div>
					<Link to={`/multischool/schools/${school.user}/edit`} className='mx-2 link'>
						<img src="/images/edit.svg" alt="Editar"/>
					</Link>
				</div>
		}
	]

    return (
		<>
			<Container className='cuerpo'>
				<Row className='mb-4'>
					<Col className='d-flex align-items-center'>
						<img src="/images/menus/experiencia.svg" alt="Icono Procesos" width={24}/>
						<h1 className='ms-2 m-0'>{t('admin.dashboard.schools')}</h1>
					</Col>
				</Row>
                <Row className="mt-2">
					<Col>
						<Card className='mb-5 sombra'>
                            <Card.Body className='px-5 py-5 selection'>
								<Row>
									<Col xs={12} className='d-flex justify-content-end'>
										<Link to='/multischool/schools/new' className='btn btn-primary'>
											<i className='fas fa-plus me-2'></i> {t('admin.dashboard.createSchool')}
										</Link>
									</Col>
								</Row>
								<Row>
									<Col>
									{schools?.length > 0
										?
											<CustomDataTable
												columns={columns}
												data={schools}
												defaultSortField="startDate"
												defaultSortAsc={true}
											/>
										:
											<div className='text-center mt-5'>{t('selection.thereisnotprocess')}</div>
									}
									</Col>
								</Row>
							</Card.Body>
						</Card>
					</Col>
				</Row>
            </Container>
        </>
    )
}